/*
 * Seed IM - Service to manage configuration for the app stored in the repo.
 */
import { Injectable } from '@angular/core';

import { forkJoin, Observable, of } from 'rxjs';

//import { HttpClient } from '@angular/common/http';
import { ContentApiService } from '@alfresco/aca-shared';

//import { AlfrescoApiService } from '@alfresco/adf-core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Node, NodesApi } from '@alfresco/js-api';
import { AuthenticationService, NotificationService, ConfirmDialogComponent } from '@alfresco/adf-core';
import { AlfrescoApiService, PeopleContentService } from '@alfresco/adf-content-services';
import { DocuServeConfigurationService } from './docuserve-configuration.service';
import {catchError, switchMap } from 'rxjs/operators';
import { isLocked } from '@alfresco/aca-shared';
import { AppStore, ReloadDocumentListAction, SetSelectedNodesAction } from '@alfresco/aca-shared/store';
import { Store } from '@ngrx/store';
import { LogService } from '@alfresco/adf-core';
import { MatDialog } from '@angular/material/dialog';

//import { Router } from '@angular/router';

interface SuccessResult {
  name: string;
  inviteUrl: string;
  isNewProject: boolean;
  inProgressCopyExists: boolean;
}

interface ErrorResult {
  apiName: string | null;  // `apiName` can be null or a string
  message: string;         // `message` is always a string
  errorCode: number;       // `errorCode` is a number
}

export interface BluebeamSession {
  isSuccess: boolean;      // `isSuccess` is a boolean
  successResult: SuccessResult | null; // `successResult` can be any type or null
  errorResult: ErrorResult[]; // `errorResult` is an array of `ErrorResult` objects


}

@Injectable()
export class BluebeamService {

  appConfig: any;
  private _nodesApi!: NodesApi;
  get nodesApi(): NodesApi {
    this._nodesApi = this._nodesApi ?? new NodesApi(this.alfrescoApiService.getInstance());
    return this._nodesApi;
  }


  constructor(

    private contentApi: ContentApiService,
    private http: HttpClient,
    private authenticationService: AuthenticationService,
    private configService: DocuServeConfigurationService,
    private notificationService: NotificationService,
    private peopleService: PeopleContentService,
    private alfrescoApiService: AlfrescoApiService,
    private store: Store<AppStore>,
    private logService: LogService,
    private dialog: MatDialog) {

    //this.nodesApi = new NodesApi(this.alfrescoApiService.getInstance());


  }

  getAppConfigFileContentUrl(nodeId: string): string {
    //this.logService.trace('getAppConfigFileContentUrl method', nodeId);
    return this.contentApi.getContentUrl(nodeId);
  }
  getAppConfigFileContent(nodeId: string){
    //this.logService.trace("this.getAppConfigFileContentUrl(nodeId)", nodeId);

    return this.http.get(this.getAppConfigFileContentUrl(nodeId));
  }

  onActionEditInBluebeam(node: Node): void {
    if (node && this.isFile(node) && node.properties) {
      if (node.isLocked) {
        // const checkedOut = node.aspectNames.find(
        //   (aspect: string) => aspect === 'cm:checkedOut'
        // );
        const checkedOut = node.properties['cm:lockType'] === 'WRITE_LOCK' || node.properties['cm:lockType'] === 'READ_ONLY_LOCK';
        const lockOwner = node.properties['cm:lockOwner'];
        const differentLockOwner = lockOwner.id !== this.authenticationService.getEcmUsername();

        if (checkedOut && differentLockOwner) {
          this.onAlreadyLockedNotification(node.id, lockOwner.id);
        } else {
          this.triggerEditInBluebeam(node);
        }
      } else {
        this.triggerEditInBluebeam(node);
      }
    }
  }

  private triggerEditInBluebeam(node: Node): void {

    // let nodeId = this.getNodeId(node);
    // let userName = this.authenticationService.getUsername;

    // let url: string = this.appConfig.bluebeam.url;
    // let subscriptionKey = this.appConfig.bluebeam.subscriptionKey;


    //this.logService.trace("triggerEditInBluebeam");

    this.getBluebeamInfo('EditFile', node, '').subscribe((result) => {
      if (result) {
        console.log('Bluebeam flow completed successfully');
      } else {
        console.log('Bluebeam flow failed or cancelled');
      }
    });

  }

  private getBluebeamInfo(actionUrl: string, node: Node, action: string) : Observable<any>{
    return forkJoin([this.configService.getAppConfig(), this.peopleService.getCurrentUserInfo()]).pipe(
      // Once both requests are done, perform a final operation using switchMap
      switchMap(([appConfig, userInfo]) => {
        // this.logService.trace("appConfig: subkey $s", appConfig.bluebeam.subscriptionKey);
        // this.logService.trace("appConfig: url: $s", appConfig.bluebeam.sessionUrl);
        // this.logService.trace("nodeId %s", this.getNodeId(node));
        this.logService.trace('userInfo', [userInfo]);
        // Define headers for the final POST request
        const headers = new HttpHeaders({
          'Content-Type': 'application/json', // Example header
          'Ocp-Apim-Subscription-Key': appConfig.bluebeam.subscriptionKey // Add subscription header (if needed)
        });

        let { firstName, lastName, displayName } = userInfo;
        // Trim and filter out any falsy values like undefined, null, or empty strings
        let nameParts = [firstName, lastName].filter(Boolean);
        let userName = nameParts.join(' ');

        if (!userName) {
          userName = displayName || this.authenticationService.getUsername();
        }

        this.notificationService.openSnackMessage('JOB-DOCUMENTS.ACTIONS.OPEN-IN-BLUEBEAM.MESSAGES.OPENED_IN_BLUEBEAM', undefined, {
          nodeName: node.name
        });
        // Here, you can use the results of both requests for a final operation
        //return this.http.post<BluebeamSession>('/external/bluebeam-funcapp/EditFile', {
        return this.http.post<BluebeamSession>(
          appConfig.bluebeam.sessionUrl + '/' + actionUrl,
          {
            fileId: this.getNodeId(node),
            userName: userName,
            userEmail: userInfo.email,
            documentName: node.name,
            action: action
          },
          { headers }
        );

        // Example request - can be used for testing.
        //   return this.http.post('/external/bluebeam-funcapp/EditFile', {
        //     fileId: "a33ce4de-67ae-42aa-a668-d454ec53a532",
        //     userName: "Sreenath",
        //     userEmail: "sreenath.angamuthu@carlislehomes.com.au",
        //     documentName: node.name
        //   },
        //   {headers}
        // );
      }),
      switchMap((response: BluebeamSession) => {
        //this.logService.trace('Final response from the last API call:', response);
        /**
         * Expected response
         *
         */
        //open the url in a new tab
        if (response == null) {
          this.bluebeamSessionError(node.name, 'empty response from editFile request', 500);
          return of(false);
        }

        //let success = ;
        //this.logService.trace("success", success);

        if (response.isSuccess) {

          //let isNewSession = response.successResult?.isNewSession;

          //let isProgressCopyExists = response.successResult?.inProgressCopyExists;
          //this.logService.trace("isNewSession", isNewSession);
          // lock the node

          const { isNewProject, inProgressCopyExists, inviteUrl } = response.successResult || {};
          const flag = actionUrl == 'EditFile' ? inProgressCopyExists : false;
          if (!flag && inviteUrl) {
            if(isNewProject){
              this.openInviteInNewTab(inviteUrl);
            }
            this.lockEditedNode(node);
            return of(true);
          } else if (flag) {
            const dialogRef = this.dialog.open(ConfirmDialogComponent, {
              data: {
                title: 'Confirm Action',
                message:
                  'You have a previous unsaved copy of this document in Bluebeam.  Do you want to continue with your existing copy, or start with a fresh copy from Alfresco?\n'+
                  '\n'+
                  'If you select Start Fresh, the local copy of the document will be overwritten, and you will lose the edited data.\n'+
                  '\n'+
                  'To Start Fresh, please close and re-open Bluebeam.',
                yesLabel: 'Continue with my copy',
                noLabel: 'Start Fresh'
              },
              minWidth: '250px'
            });
            return dialogRef.afterClosed().pipe(
              switchMap((result: boolean) => {
                const nextAction = result ? 'Continue' : 'StartFresh';
                // Call getBluebeamInfo again with the chosen action
                return this.getBluebeamInfo('ConfirmEditFile', node, nextAction);
              })
            );
          } else {
            console.log('Not a valid response: ' + response.successResult);
            return of(false);
          }
        } else {
          // notify of error
          const { message, errorCode } = response.errorResult[0];
          this.bluebeamSessionError(node.name, message, errorCode);
          return of(false);
        }
      }),
      catchError((error: HttpErrorResponse) => {
        console.error('Error:', error.error.errorResult[0].message);
        const err = error?.error?.errorResult?.[0];
        this.bluebeamSessionError(node.name, err?.message || 'Unknown error occurred.', err?.errorCode || 500);
        return of(false);
      })
    );
  }

  // getUserInfo() {
  //   throw new Error('Method not implemented.');
  //   this.peopleService.getCurrentUserInfo().pipe();
  // }

  openByUrl(protocolHandler: string, url: string) {
    const finalUrl = protocolHandler + ':ofe%7Cu%7C' + url;

    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = finalUrl;

    document.body.appendChild(iframe);

    setTimeout(() => {
      if (iframe) {
        document.body.removeChild(iframe);
      }
    }, 500);
  }

  private isFile(node: Node): boolean {
    const implicitFile = (node as any).nodeId || (node as any).guid;

    return !!implicitFile || node.isFile;
  }

  private getNodeId(node: Node): string {
    return (node as any).nodeId || (node as any).guid || node.id;
  }

  private onAlreadyLockedNotification(nodeId: string, lockOwner: string) {
    this.notificationService.showError(`JOB-DOCUMENTS.ACTIONS.OPEN-IN-BLUEBEAM.ERRORS.ALREADY_LOCKED`, undefined, {
      nodeId,
      lockOwner
    });
  }

  private bluebeamSessionError(nodeName: string, errorMessage: string, errorCode: number) {
    this.logService.debug("Error code", errorCode);
    this.notificationService.showError(`JOB-DOCUMENTS.ACTIONS.OPEN-IN-BLUEBEAM.ERRORS.GET-SESSION-ERROR`, undefined, {
      nodeName,
      errorMessage
    });

  }

  openInviteInNewTab(inviteUrl: string) {

    // var url = this.router.serializeUrl(
    //   this.router.createUrlTree(['/aev/preview', nodeId])
    // );
    //url = url.replace("/aev", "/#/aev");
    //this.logService.trace("Opening the invite Url", inviteUrl);
    //let newWindow =
    window.open(inviteUrl, '_blank'); // Open the URL in a new tab

  }

  private async lockEditedNode(node: Node) {
    const id = this.getNodeId(node);

    if (!isLocked({ entry: node })) {

      try {
        await this.lockNode(id);
        //this.logService.trace("lock response", response);

        this.store.dispatch(new ReloadDocumentListAction());
        // this.store.dispatch(new DownloadNodesAction([this.selection]));
        // this.store.dispatch(new EditOfflineAction(this.selection));
        this.store.dispatch(new SetSelectedNodesAction([{entry: node}]));
      } catch(error) {
        //this.logService.trace("Lock error", error);
        this.onLockError(node);
      }
    }
  }

  lockNode(nodeId: string) {

    //this.logService.trace("Node api", this.nodesApi, nodeId);
    //this.nodesApi.getNode("-my-").then(value => this.logService.trace("Node returned", value));
    return this.nodesApi.lockNode(nodeId, {
      type: 'ALLOW_OWNER_CHANGES',
      lifetime: 'PERSISTENT'
    });
  }

  onLockError(node: Node) {
    this.notificationService.showError('APP.MESSAGES.ERRORS.LOCK_NODE', undefined, { fileName: node.name });
  }


}
